export default "__VITE_ASSET__DTzmpSSg__"